var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 22,
    viewBox: "0 0 36 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "zzwa287cfa",
    d: "M0.029 0.018L5.073 0.018 5.073 7.326 0.029 7.326z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v3lq94gysc",
    d: "M0.25 0.015L0.401 0.015 0.401 0.275 0.25 0.275z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "75z4scxi6e",
    d: "M0.075 0.101L0.325 0.101 0.325 0.25 0.075 0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wvqy1jck2g",
    d: "M0.037 0.023L1.659 0.023 1.659 1.842 0.037 1.842z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68 -89) translate(68 89)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5,
    height: 21.5,
    x: 0.25,
    y: 0.25,
    fill: "#FFF",
    stroke: "#C7C7C7",
    strokeWidth: 0.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M.053 4.07c.021-.056.019-.116.028-.174.078-.503.262-.956.624-1.324.286-.29.634-.466 1.035-.544.337-.065.652.005.963.126.116.045.233.087.348.133.186.076.367.07.554-.001.204-.078.405-.162.615-.222.18-.052.362-.092.547-.086.619.02 1.138.24 1.5.767.016.022.012.03-.01.044-.405.268-.68.63-.788 1.109-.04.178-.039.358-.024.54.019.24.084.468.203.68.17.303.418.526.722.692.025.014.05.031.078.04.049.013.05.04.035.081-.088.272-.205.53-.35.777-.162.279-.336.55-.547.795-.151.175-.32.327-.54.412-.233.09-.468.08-.702.007-.139-.043-.268-.11-.403-.16-.379-.14-.752-.121-1.123.033-.132.055-.26.117-.4.155-.22.061-.44.074-.653-.032-.133-.066-.249-.155-.355-.257-.205-.2-.368-.432-.529-.667C.501 6.44.256 5.828.127 5.17c-.03-.155-.053-.31-.064-.467-.001-.008 0-.016-.01-.02v-.528c.008-.019.008-.037 0-.056V4.07z",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6) translate(18.182 2.598)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "daswi5ggmb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#zzwa287cfa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M.957 7.326c-.046-.018-.095-.014-.143-.018-.071-.006-.142-.01-.213-.014-.027-.002-.038-.012-.038-.043V6.44c0-.026 0-.036.037-.033.196.016.392.025.586-.015.242-.05.412-.191.533-.401.094-.164.135-.345.196-.52.03-.09.025-.167-.007-.256C1.283 3.5.662 1.785.04.07.02.02.02.02.077.02l1.08-.001c.035 0 .049.01.059.042l1.32 4.244c.006.018.002.051.028.05.017 0 .016-.032.022-.05.441-1.414.882-2.828 1.321-4.243.01-.032.022-.043.056-.043h1.073c.034 0 .045.003.031.041L3.093 5.63c-.109.305-.234.602-.408.877-.195.307-.444.552-.79.684-.192.074-.391.112-.595.127-.01 0-.023-.006-.027.01h-.084c-.015-.008-.03-.008-.046 0H.957z",
    mask: "url(#daswi5ggmb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6) translate(0 4.095)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "kswsx13uyd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v3lq94gysc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#424040",
    d: "M.25.015c.077.087.06.173 0 .26v-.26z",
    mask: "url(#kswsx13uyd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6) translate(19.305 9.87)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9ryw9fscjf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#75z4scxi6e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#403E3D",
    d: "M.092.25C.164.191.237.181.309.25H.092z",
    mask: "url(#9ryw9fscjf)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M7.787 4.255V.665C7.785.623 7.794.61 7.84.61l2.673.001c.422 0 .828.078 1.206.273.482.247.824.625 1.031 1.124.105.254.16.52.18.794.026.352-.006.697-.118 1.032-.228.685-.684 1.155-1.358 1.413-.248.095-.506.143-.77.16-.103.007-.205.008-.307.008l-1.401-.001c-.04 0-.05.008-.05.05.001.795 0 1.592.002 2.388 0 .04-.01.05-.05.05-.347-.002-.693-.002-1.04 0-.042 0-.053-.01-.053-.053l.001-3.594M17.783 6.036v1.836c0 .037-.005.05-.046.05-.317-.003-.634-.002-.951-.001-.037 0-.05-.007-.049-.047.002-.255.001-.51.001-.765v-.023c-.002-.011.007-.029-.01-.032-.014-.002-.016.016-.022.026-.043.077-.09.15-.145.22-.252.32-.58.524-.969.637-.26.076-.525.093-.793.067-.302-.028-.587-.11-.846-.27-.386-.238-.622-.581-.7-1.03-.05-.295-.033-.583.083-.862.127-.305.348-.524.631-.684.268-.151.558-.233.86-.281.27-.042.541-.05.813-.064l1.014-.055c.015-.001.027 0 .026-.022-.007-.212.02-.427-.029-.637-.064-.277-.225-.474-.487-.588-.226-.098-.462-.114-.704-.094-.206.017-.4.071-.574.186-.191.125-.313.302-.37.523-.01.04-.02.057-.067.057-.314-.003-.628-.003-.942 0-.043 0-.05-.012-.046-.052.06-.59.363-1.02.87-1.314.256-.147.533-.231.823-.276.26-.041.523-.05.786-.028.387.033.757.124 1.089.335.406.258.65.626.727 1.103.019.114.027.23.027.346v1.739",
    transform: "translate(6 6)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6) translate(3.209 .03)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jpxv5ywnbh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wvqy1jck2g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M.193 1.84c-.028 0-.055.002-.083 0C.043 1.84.043 1.84.04 1.77c-.01-.172.013-.34.068-.501C.326.628.769.23 1.419.056c.062-.016.128-.02.191-.032.032-.006.041.005.044.038.031.371-.078.705-.264 1.02-.19.323-.456.557-.808.69-.124.047-.254.074-.389.069",
    mask: "url(#jpxv5ywnbh)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M8.909 3.025l-.001-1.4c0-.038.008-.048.048-.048l1.238.001c.26.001.518.027.762.126.396.16.647.446.748.86.082.335.084.67-.023 1-.134.415-.42.679-.831.812-.21.069-.428.092-.648.093-.416.002-.832 0-1.248.001-.035 0-.046-.007-.046-.044v-1.4M16.68 5.818c.006.142 0 .318-.061.49-.096.269-.27.477-.513.622-.369.218-.766.276-1.18.164-.248-.068-.444-.211-.533-.464-.12-.343-.007-.7.337-.882.186-.098.386-.141.594-.156.288-.02.576-.036.865-.054l.463-.028c.029-.003.028.01.028.031v.277",
    transform: "translate(6 6)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentApple);
export default __webpack_public_path__ + "static/media/payment-apple.629c5068e4c830ac1a1c0b6c9d5b09c5.svg";
export { ForwardRef as ReactComponent };